import { constants, actions } from 'ducks-helpers';

//  SUFFIXES
// [
//   'LOADING',
//   'PENDING',
//   'SUCCESS',
//   'ERROR',
//   'FAILED',
//   'CANCELED'
// ]

export const TYPE = constants('reports/remainder', [
    '~FETCH_REMAINDERS_REPORT',
    '~FETCH_TOTAL_REMAINDERS',
    'EXPORT_TO_EXCEL'
]);

export const ACTION = actions(TYPE);
